<div class="animated fadeIn">
    <div class="row">
        <div class="col-12">
            <p class="text fs-14">Calcula tus ganancias, simula tu inversión y comienza a <br> hacer tu patrimonio.</p>
            <div class="d-md-flex align-items-center div-container">
                <div class="col-6 pe-4 my-2">
                    <div class="mont ">
                        <form [formGroup]="formCalculate">
                            <div class="d-flex align-items-center justify-content-between pt-1 pb-4">
                                <p class="m-0">1. Monto de inversión</p>
                                <div class="d-md-flex justify-content-end content-t">
                                    <button class="btn p-0" (click)="lessInit()"><img class="less-icon" src="/assets/icons/less-icon.svg" alt=""></button>
                                    <input type="text" currencyMask class="remove-input" formControlName="initAmount" (ngModelChange)="editInput()">
                                    <button class="btn p-0" (click)="sumInit()"><img class="sum-icon" src="/assets/icons/more-icon.svg" alt=""></button>
                                </div>
                            </div>

                            <div class="py-3 slider-st">
                                <ngx-slider [value]="initAmount.value" (valueChange)="editValue($event)" [options]="options" class="fs-14"></ngx-slider>
                            </div>
                        </form>
                    </div>

                    <div class="info">
                        <div class="border-bottom text2">
                            <p>Al invertir <strong>{{ initAmount.value | currency: '$' }}</strong> ganarás <strong>{{ totalPerformance | currency: '$' }}</strong> en rendimientos.</p>
                        </div>
                        <div class="text3 p-3">
                            @if(infoProject?.state !== 'residential') {
                                <p class="fs-16"><strong>{{ getTextByCapitalization(infoProject?.capitalization) }} recibirás {{ repartEstimate | currency: 'MXN'}}</strong> de rendimiento y al finalizar el plazo, recibirás tus <strong>{{ initAmount?.value | currency: 'MXN':'symbol':'1.0-0'}} invertidos. </strong> <span *ngIf="infoProject?.soldPerformance">más una utilidad por venta estimada de <strong>{{soldTotalPerformance | currency: 'MXN'}}</strong></span></p>
                            } @else if(infoProject?.state == 'residential') {
                                <p class="fs-16"><strong>En un plazo de 3 hasta 5 meses máximo recibirás {{ totalPerformance |currency: 'MXN' }} de rendimiento y tus {{ initAmount?.value | currency: 'MXN' }} invertidos.</strong></p>
                            }
                        </div>
                    </div>
                    <p class="fs-12 cl-black text-end mt-2"><span class="cl-black text-decoration-underline cr-pointer" (click)="showInfoText = !showInfoText">Consideraciones para el cálculo</span></p>

                    <div class="text-end fs-12 fw-italic animated fadeIn fast" *ngIf="showInfoText">
                        <p>
                            Esta simulación tiene la finalidad de orientar sobre posibles resultados y no debe ser entendida como un indicador de rendimiento garantizado. El resultado que obtenga cada persona dependerá de las inversiones realizadas y su recuperación.<br><br>
                            El cálculo se realiza sobre el plazo total del proyecto. En caso de que el proyecto tenga un plazo indefinido, se considera un período de 5 años para el cálculo. <br><br>
                            La simulación no incluye la comisión de Monific, consulta los costos y comisiones de nuestros productos <a href="https://monific.com/legal/costos-y-comisiones" target="_blank">aquí</a>
                        </p>
                    </div>
                </div>


                <div class="col-6 ps-4 div-2">
                    <div class="inverted d-md-flex justify-content-between align-items-center">
                        <p><img class="me-2" src="/assets/icons/icon-simulator-1.svg" alt=""> Inversión inicial:</p>
                        <p class="sm-bold fs-14">{{ initAmount.value | currency: 'MXN' }} MXN</p>
                    </div>
                    <div class="rendimiento d-md-flex justify-content-between">
                        <p><img class="me-2" src="/assets/icons/icon-simulator-2.svg" alt="">Rendimiento total:</p>
                        <p class="sm-bold fs-14">{{ totalPerformance | currency: 'MXN' }} MXN</p>
                    </div>
                    <div class="total d-md-flex justify-content-between">
                        <p><img class="me-2" src="/assets/icons/icon-simulaor-3.svg" alt="">Total a recibir:</p>
                        <p class="sm-bold fs-14">{{ totalSum | currency: 'MXN' }} MXN</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
